import { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';
import { useAuth } from '../../hooks/useAuth';

export const UnreadMessagesBadge = () => {
  const [unreadCount, setUnreadCount] = useState(0);
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    const fetchUnreadCount = async () => {
      try {
        const { data, error } = await supabase
          .from('conversation_participants')
          .select('unread_count')
          .eq('user_id', user.id);

        if (error) {
          console.error('Error fetching unread count:', error);
          return; // Silencieusement échouer
        }

        if (data) {
          const total = data.reduce((sum, item) => sum + (item.unread_count || 0), 0);
          setUnreadCount(total);
        }
      } catch (error) {
        console.error('Error in UnreadMessagesBadge:', error);
      }
    };

    fetchUnreadCount();

    const channel = supabase
      .channel('messages_changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'conversation_participants',
          filter: `user_id=eq.${user.id}`
        },
        () => {
          fetchUnreadCount();
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [user]);

  if (unreadCount === 0) return null;

  return (
    <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs font-medium rounded-full flex items-center justify-center">
      {unreadCount}
    </span>
  );
}; 